<template>
    <div>
        <div
            class="uk-grid-small uk-child-width-1-2@m uk-child-width-1-1"
            uk-grid>
            <div v-for="p in placeholders" :key="p">
                <TextField :label="p" v-model="values[p]" :name="p" is-round />
            </div>
        </div>

        <div class="uk-margin-medium-top" />

        <Button
            is-round
            mode="primary"
            is-large
            is-max
            has-action
            :action="send"
            :is-loading="loading">
            <Translate translation-key="email.send" />
        </Button>

        <div v-if="error" class="uk-margin-top" />
        <ErrorMessage :error="error" />

        <div v-if="success" class="uk-margin-top" />
        <SuccessMessage :success="success" :message="$t('email.sent')" />
    </div>
</template>

<script>
import axios from 'axios';
import Button from '@/components/generic/Button.vue';
import ErrorMessage from '@/components/generic/ErrorMessage.vue';
import SuccessMessage from '@/components/generic/SuccessMessage.vue';
import Translate from '@/components/Translate.vue';
import TextField from '@/components/generic/TextField.vue';

export default {
    name: 'ClickAndBuyTestEmailForm',
    components: {
        TextField,
        Button,
        ErrorMessage,
        SuccessMessage,
        Translate,
    },
    props: {
        clickAndBuyId: {type: String, required: true},
        placeholders: {type: Array, required: true},
    },
    data() {
        return {
            values: {},
            loading: false,
            success: false,
            error: null,
        };
    },
    methods: {
        send() {
            const placeholders = {};
            for (const [k, v] of Object.entries(this.values)) {
                if (v && v !== '') placeholders[k] = v;
            }

            this.loading = true;
            this.error = null;
            this.success = false;

            axios
                .post(
                    `${this.apiUrl}/manage-clickandbuys/${this.clickAndBuyId}/test-email`,
                    {placeholders}
                )
                .then(() => {
                    this.success = true;
                })
                .catch((e) => {
                    this.checkGenericError(e);
                    this.error = e;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
